<template>
<div class="chapter">
<div class="inner_page">
<div style="text-align:center;"><img alt="9781615954636_FCHigh.jpg" src="Images/9781615954636_FCHigh.jpg" style="max-width:100%;"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// CoverImage.vue?94385cde